module.exports = __webpack_public_path__ + "img/lageplan_1280.8255147e.jpg";